(() => {
  const initializedGalleries = new WeakSet();
  const desktopHover = window.matchMedia(
    '(hover: hover) and (pointer: fine) and (min-width: 750px)'
  );

  function initializeGallery(gallery) {
    if (
      !gallery ||
      initializedGalleries.has(gallery) ||
      !gallery.hasAttribute('data-hover-zoom')
    ) {
      return;
    }

    initializedGalleries.add(gallery);

    const zoomScale =
      Number.parseFloat(gallery.dataset.hoverZoomScale) || 2;

    const imageOpeners = gallery.querySelectorAll(
      '.product__modal-opener--image'
    );

    imageOpeners.forEach((opener) => {
      const mediaContainer = opener.querySelector(
        '.product__media'
      );

      const image = mediaContainer?.querySelector('img');

      if (!mediaContainer || !image) return;

      /*
       * Remove Dawn's click magnifier from this image.
       * The modal opener and normal image click remain unchanged.
       */
      image.onclick = null;
      image.classList.remove('image-magnify-hover');
      image.classList.add('product-hover-zoom__image');

      image.style.setProperty(
        '--product-hover-zoom-scale',
        zoomScale
      );

      const handlePointerMove = (event) => {
        if (!desktopHover.matches) return;

        const rectangle =
          mediaContainer.getBoundingClientRect();

        if (!rectangle.width || !rectangle.height) return;

        const pointerX = Math.min(
          Math.max(event.clientX - rectangle.left, 0),
          rectangle.width
        );

        const pointerY = Math.min(
          Math.max(event.clientY - rectangle.top, 0),
          rectangle.height
        );

        const originX =
          (pointerX / rectangle.width) * 100;

        const originY =
          (pointerY / rectangle.height) * 100;

        image.style.transformOrigin =
          `${originX}% ${originY}%`;

        image.classList.add(
          'product-hover-zoom__image--active'
        );
      };

      const resetZoom = () => {
        image.classList.remove(
          'product-hover-zoom__image--active'
        );

        image.style.transformOrigin = '50% 50%';
      };

      opener.addEventListener(
        'pointermove',
        handlePointerMove
      );

      opener.addEventListener(
        'pointerleave',
        resetZoom
      );

      opener.addEventListener(
        'pointercancel',
        resetZoom
      );
    });
  }

  function initializeAllGalleries(container = document) {
    if (
      container.matches?.(
        'media-gallery[data-hover-zoom]'
      )
    ) {
      initializeGallery(container);
    }

    container
      .querySelectorAll?.(
        'media-gallery[data-hover-zoom]'
      )
      .forEach(initializeGallery);
  }

  function start() {
    initializeAllGalleries();

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initializeAllGalleries(event.target);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();